if (!customElements.get('mermacorn-panorama')) {
  customElements.define('mermacorn-panorama', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-header-action]').forEach(link => link.addEventListener('click', event => {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const search = link.dataset.headerAction === 'search';
        const target = document.getElementById(search ? 'search-modal' : 'cart-drawer');
        const method = search ? 'showDialog' : 'open';
        if (typeof target?.[method] !== 'function') return;
        target[method]();
        event.preventDefault();
      }, options));
      const viewport = this.querySelector('.mc-panorama__viewport');
      if (viewport) {
      const buttons = [...this.querySelectorAll('[data-pan]')];
      const update = () => buttons.forEach(button => {
        button.disabled = Number(button.dataset.pan) < 0 ? viewport.scrollLeft <= 1 : viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 1;
      });
      buttons.forEach(button => button.addEventListener('click', () => {
        viewport.scrollBy({ left: Number(button.dataset.pan) * viewport.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options));
      viewport.addEventListener('scroll', update, { ...options, passive: true });
      this.observer = new ResizeObserver(update);
      this.observer.observe(viewport);
      update();

      }

      if (this.querySelector('.mc-panorama__nav')) {
        const nav = this.querySelector('.mc-panorama__nav');
        const slot = document.createElement('div');
        slot.className = 'mc-panorama__nav-slot';
        nav.before(slot);
        slot.append(nav);
        this.stickyNav = nav;
        this.stickySlot = slot;
        const sync = () => {
          this.stickyFrame = null;
          const bounds = slot.getBoundingClientRect();
          const pinned = bounds.top <= 0;
          const focused = nav.contains(document.activeElement) ? document.activeElement : null;
          if (pinned !== nav.classList.contains('mc-panorama__nav--pinned')) {
            nav.classList.toggle('mc-panorama__nav--pinned', pinned);
            (pinned ? document.body : slot).append(nav);
            focused?.focus({ preventScroll: true });
          }
          if (pinned) {
            nav.style.left = bounds.left + 'px';
            nav.style.width = bounds.width + 'px';
          } else {
            nav.style.removeProperty('left');
            nav.style.removeProperty('width');
          }
          const height = nav.getBoundingClientRect().height;
          slot.style.height = height + 'px';
          document.body.style.setProperty('--mc-nav-height', height + 'px');
        };
        const schedule = () => {
          if (this.stickyFrame == null) this.stickyFrame = requestAnimationFrame(sync);
        };
        document.addEventListener('scroll', schedule, { ...options, passive: true, capture: true });
        window.addEventListener('resize', schedule, { ...options, passive: true });
        this.stickyObserver = new ResizeObserver(schedule);
        this.stickyObserver.observe(nav);
        this.stickyObserver.observe(slot);
        sync();
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.stickyFrame);
      this.stickyFrame = null;
      this.stickyObserver?.disconnect();
      if (this.stickyNav && this.stickySlot) {
        this.stickyNav.classList.remove('mc-panorama__nav--pinned');
        this.stickyNav.style.removeProperty('left');
        this.stickyNav.style.removeProperty('width');
        this.stickySlot.replaceWith(this.stickyNav);
        document.body.style.removeProperty('--mc-nav-height');
        this.stickyNav = null;
        this.stickySlot = null;
      }
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  });
}
